export default {"src":"/_next/static/media/with_values_logo.14f89b4d.svg","height":50,"width":313};